import React, {useContext, useEffect, useState} from 'react';
import { Button, Container, Stack, Typography, Backdrop, CircularProgress, Dialog } from '@mui/material';
import Header from './Header';
import Sms from './sms';
import { access_list, API } from '../conf';
import { Context } from '../App';

const Home = () => {
    const {agentAccess, updateConnect} = useContext(Context)
    const [sessions, setSessions] = useState([])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [load, setLoad] = useState(false)

    function getSessions() {
        setLoad(true)
        fetch(API.concat(`/Session/by/${JSON.stringify({active: true})}`), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{  
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setSessions(json)
                    manageDialog(true, 'sessions')
                }setLoad(false)
            }
        })
    }

    function manageDialog(open, action){
        setAction(action)
        setOpen(open)
    }

    useEffect(()=>{}, [agentAccess])

    return (
        <>
            <Header/>
            <Container sx={{marginTop:2}}>
                <Typography variant="h3" textAlign='center' gutterBottom>
                    Accueil
                </Typography>
                <Stack direction='row' flexWrap='wrap' rowGap={2} columnGap={2} alignItems='center' justifyContent='center'>
                    {access_list.filter(acces=>agentAccess?.includes(acces.Value)&&!['/realtime_presence/:sessionId', 'sms'].includes(acces.Value)).map(acces=><Button key={acces.Value} variant="outlined" href={acces.Value}>{acces.ButtonLabel}</Button>)}
                    <Button variant="outlined" onClick={getSessions}>Présences</Button>
                    {agentAccess?.includes('sms')&&<Button variant="outlined" onClick={()=>manageDialog(true, 'sms')}>SMS</Button>}
                </Stack>
            </Container>
            <Dialog open={open} onClose={()=>manageDialog(false, '')} maxWidth={action==='sms'?'md':'xs'} fullWidth>
                {action==='sessions'&&<Stack direction='column' alignItems='center' justifyContent='center' spacing={2} sx={{padding:2}}>
                    <Typography variant="h5">Sessions actives</Typography>
                    {sessions.map(session=><Button key={session._id} variant="clear" href={`/realtime_presence/${session._id}`}>{session.label+(session.isRepas?'(repas)':'')}</Button>)}
                </Stack>}
                {action==='sms'&&<Sms setLoad={setLoad} close={()=>manageDialog(false, '')} />}
            </Dialog>
            <Backdrop open={load}><CircularProgress color="inherit" /></Backdrop>
        </>
    );
};

export default Home;